const DOWNLOAD_NAMES = {
    asset: "asset-import-example.csv",
    shot: "shot-import-example.csv",
    sequence: "sequence-import-example.csv",
    shotversion: "shotversion-import-example.csv",
    assetversion: "assetversion-import-example.csv",
};

export const downloadExampleCsv = async (trackableType) => {
    const filename = DOWNLOAD_NAMES[trackableType];
    if (!filename) return;

    const base = process.env.PUBLIC_URL || "";
    const res = await fetch(`${base}/csv-import-examples/${trackableType}.csv`);
    if (!res.ok) return;

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
